// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__eGAdE","active":"Navigation_active__lVgmf","spin":"Navigation_spin___ZU_y","loader":"Navigation_loader__rqDW6"};